//
//
//
//
//
//
//
//

const prefix = 'mg-btn';
export default {
  name: 'mg-button',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    size: {
      type: String,
      default: 'normal',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    btnClass() {
      return ['mg-btn', `${prefix}-${this.type}`, { disabled: this.disabled }];
    },
  },
  methods: {
    handleClick() {
      this.$emit('click');
    },
  },
};
